import { Skeleton } from "@chakra-ui/react";
import { currency } from "@src/utils/formatters";

interface CreditBalanceProps {
  isProBono: boolean;
  creditBalance: number;
  fetching?: boolean;
}

export const CreditBalance = (props: CreditBalanceProps) => {
  return (
    <div className="flex justify-center">
      {props.isProBono ? (
        "N/A"
      ) : (
        <Skeleton h="3" isLoaded={!props.fetching}>
          {currency.formatByWorkspace(props.creditBalance)}
        </Skeleton>
      )}
    </div>
  );
};
